import voxMarkUrl from "../assets/brand/vox-mark.png";

export function Brand({ context }: { context?: string }) {
  return (
    <a className="brand" href="/" aria-label="Vox">
      <span className="brand-mark" aria-hidden="true">
        <img src={voxMarkUrl} alt="" />
      </span>
      <span className="brand-name">Vox</span>
      {context ? <span className="brand-context">{context}</span> : null}
    </a>
  );
}
